import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import Email from './Email';
import LocalizedAddress from './LocalizedAddress';
import Props from'./CustomerComponent';
import { isKioskMode } from '../../../selectors/ui';
import { TranslationContext } from '../../../../checkout/config/Translations';
import { bindActionCreators } from 'redux';
import { validateMemberField } from '../actions/member';
import LeapOptInContainer from 'checkout/views/checkout/containers/LeapOptInContainer';
import { getIsNameFieldDisabled } from '../../../selectors/reservation';
import Name from '@showclix-shared/CheckoutProcess/components/fields/Name';
import Phone from '@showclix-shared/CheckoutProcess/components/fields/Phone';

class Customer extends Component<Props> {
    onBlur = (field, required = true) => () => {
        if(required) {
            this.props.validateMemberField(field);
        }
    }

    render() {
        if (this.props.showName === false && this.props.showEmail === false && !this.props.showPhone && !this.props.showAddress) {
            return null;
        }
        return(
            <>
            <TranslationContext.Consumer>
            {t =>
                <section className="checkout-form__section">
                    <div className="form-card">
                        {!this.props.isKioskMode &&
                            <div className="form-card__header">
                                <h4 className="form-card__heading">{t.t("checkout__contact_info")}</h4>
                            </div>
                        }
                        <form className="form-card__content">
                            {this.props.showName !== false && <Name
                                id="customerFullName"
                                name={this.props.name}
                                onNameChange={this.props.onNameChange}
                                required={this.props.nameRequired !== false}
                                showRequiredLabel={false}
                                onFocus={this.props.onNameFocus}
                                onBlur={this.onBlur('name', this.props.nameRequired !== false)}
                                error={this.props.errors['name']}
                                disabled={this.props.nameDisabled}
                            />}
                            {this.props.showEmail !== false && <Email
                                email={this.props.email}
                                onEmailChange={this.props.onEmailChange}
                                required={this.props.emailRequired !== false}
                                onFocus={this.props.onEmailFocus}
                                onBlur={this.onBlur('email', this.props.emailRequired !== false)}
                                error={this.props.errors['email']}
                            />}
                            {this.props.showPhone && <Phone
                                phone={this.props.phone}
                                onPhoneChange={this.props.onPhoneChange}
                                required={this.props.phoneRequired}
                            />}
                            { this.props.showAddress && (
                                <LocalizedAddress
                                    {...this.props.address}
                                    onAddressChange={this.props.onAddressChange}
                                    header={t.t('checkout__customer_address')}
                                />
                            )}
                        </form>
                    </div>
                </section>
            }
            </TranslationContext.Consumer>
            {this.props.show_leap_opt_in && <LeapOptInContainer/>}
            </>
        )
    }
}
const mapStateToProps = state => {
    return {
        isKioskMode: isKioskMode(state),
        errors: state.member.errors,
        show_leap_opt_in: state.ui?.uiConfig?.show_leap_opt_in && !(state.ui?.uiConfig?.browserCountry == 'US'),
        nameDisabled: getIsNameFieldDisabled(state),
        phoneRequired: state.weather?.quote?.selected ?? false
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        validateMemberField,
    }, dispatch);
}

Customer.propTypes = {
    name: PropTypes.string.isRequired,
    onNameChange: PropTypes.func.isRequired,
    email: PropTypes.string.isRequired,
    onEmailChange: PropTypes.func.isRequired,
    showPhone: PropTypes.bool,
    phone: PropTypes.string,
    onPhoneChange: PropTypes.func,
    address: PropTypes.object,
    showAddress: PropTypes.bool.isRequired,
    nameDisabled: PropTypes.bool.isRequired,
    phoneRequired: PropTypes.bool
}

Customer.defaultProps = {
    showPhone: true,
    showAddress: false
}

export default connect(mapStateToProps, mapDispatchToProps)(Customer);
